import React from 'react';
import TopAndBottomPadding from '@/src/components/Modules-revamp/ModuleStyle/TopAndBottomPaddingInput';
import { ModuleStyleField } from '@/src/strategies/util';
import BackgroundType from '@/src/components/Modules-revamp/ModuleStyle/BackgroundType';
import FullWidthBackground from '@/src/components/Modules-revamp/ModuleStyle/FullWidthBackground';
import MarginToTop from '@/src/components/Modules-revamp/ModuleStyle/MarginToTop';
import MarginToBottom from '@/src/components/Modules-revamp/ModuleStyle/MarginToBottom';
import MarginToLeft from '@/src/components/Modules-revamp/ModuleStyle/MarginToLeft';
import MarginToRight from '@/src/components/Modules-revamp/ModuleStyle/MarginToRight';
import BackgroundColor from '@/src/components/Modules-revamp/ModuleStyle/BackgroundColor';

type ResponsiveFieldProps = {
  field: ModuleStyleField;
  disabled?: boolean;
  options?: Array<{ label: string; value: any }>;
  hasModal?: boolean;
  modalFunc?: any;
};

const moduleStyleRender = (
  data: ResponsiveFieldProps,
  allDisabled?: boolean,
) => {
  switch (data?.field) {
    case ModuleStyleField.TopPadding: {
      return <TopAndBottomPadding disabled={data?.disabled || allDisabled} />;
    }
    case ModuleStyleField.BackgroundType: {
      return (
        <BackgroundType
          disabled={data?.disabled || allDisabled}
          options={data?.options || []}
        />
      );
    }
    case ModuleStyleField.FullWidth: {
      return <FullWidthBackground disabled={data?.disabled || allDisabled} />;
    }
    case ModuleStyleField.MarginToTop: {
      return <MarginToTop disabled={data?.disabled || allDisabled} />;
    }
    case ModuleStyleField.MarginToBottom: {
      return <MarginToBottom disabled={data?.disabled || allDisabled} />;
    }
    case ModuleStyleField.MarginToLeft: {
      return <MarginToLeft disabled={data?.disabled || allDisabled} />;
    }
    case ModuleStyleField.MarginToRight: {
      return <MarginToRight disabled={data?.disabled || allDisabled} />;
    }
    case ModuleStyleField.BackgroundColor: {
      return <BackgroundColor disabled={data?.disabled || allDisabled} />;
    }
  }
};

export default moduleStyleRender;
